import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../useApiMutation';

const useSetApplePodcasts = () => {
  const queryClient = useQueryClient();

  const disableApplePodcasts = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/apple-podcasts`,
    method: 'DELETE',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId, newShowData.network).show, newShowData);
    },
  });

  const enableApplePodcasts = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/apple-podcasts`,
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId, newShowData.network).show, newShowData);
    },
  });

  const addClaimToken = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/apple-podcasts/claim-token`,
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId, newShowData.network).show, newShowData);
    },
  });

  return {
    disableApplePodcasts: disableApplePodcasts.mutate,
    isDisableApplePodcastsLoading: disableApplePodcasts.isLoading,
    isDisableApplePodcastsError: disableApplePodcasts.isError,
    isDisableApplePodcastsSuccess: disableApplePodcasts.isSuccess,
    disableApplePodcastsInfo: { ...disableApplePodcasts },

    enableApplePodcasts: enableApplePodcasts.mutate,
    isEnableApplePodcastsLoading: enableApplePodcasts.isLoading,
    isEnableApplePodcastsError: enableApplePodcasts.isError,
    isEnableApplePodcastsSuccess: enableApplePodcasts.isSuccess,
    enableApplePodcastsInfo: { ...enableApplePodcasts },

    addClaimToken: addClaimToken.mutate,
    isAddClaimTokenLoading: addClaimToken.isLoading,
    isAddClaimTokenError: addClaimToken.isError,
    isAddClaimTokenSuccess: addClaimToken.isSuccess,
    addClaimTokenInfo: { ...addClaimToken },
  };
};

export default useSetApplePodcasts;
